module.exports = __webpack_public_path__ + "img/IT0000101247333.3be08bc9.png";